import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["className", "disabled", "helpfulCount", "onClickHelpful", "tooltip", "userMarkedHelpful"];
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GREAT_WHITE, KOALA, GYPSUM } from 'HubStyleTokens/colors';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
const ActiveButton = styled(UIButton).withConfig({
  displayName: "HelpfulButton__ActiveButton",
  componentId: "hujqtu-0"
})(["background-color:", " !important;font-weight:600 !important;&:hover{background-color:", " !important;}"], GREAT_WHITE, GYPSUM);
const InactiveButton = styled(UIButton).withConfig({
  displayName: "HelpfulButton__InactiveButton",
  componentId: "hujqtu-1"
})(["background-color:", " !important;font-weight:400 !important;&:hover{background-color:", " !important;}"], KOALA, GYPSUM);
export default function HelpfulButton(_ref) {
  let {
      className,
      disabled,
      helpfulCount,
      onClickHelpful,
      tooltip,
      userMarkedHelpful
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const Button = userMarkedHelpful ? ActiveButton : InactiveButton;
  return /*#__PURE__*/_jsx(UITooltip, {
    title: tooltip || /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-reviews.actions.loginRequired"
    }),
    disabled: !disabled || !tooltip,
    children: /*#__PURE__*/_jsx(Button, Object.assign({}, rest, {
      className: className,
      size: "xs",
      disabled: disabled,
      use: "tertiary-light",
      onClick: onClickHelpful,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-ui-reviews.actions.helpful",
        options: {
          count: helpfulCount
        }
      })
    }))
  });
}